import React from 'react';
import {Link} from "react-router-dom";
import '../App.css';
import megan from '../images/megan1.png';


function Home(props) {
  return (
    <div className="container">
      <div id="myName">
        <div id="header">hiii i'm megan dinh</div>
        <img id="pics" src={megan} alt="megan with matcha"/>
        <div id="tt1">
          <div id="t">where you at?</div>
          <div id="b1">currently &#64; amazon</div>
        </div>
        <div id="tt1">
          <div id="t">say hiii back</div>
          <div id="links">
            <a id="b1" href="mailto:dinhmegann@gmail.com">(dinhmegann@gmail.com)</a>
            <a id="b1" href="https://www.linkedin.com/in/megandinhdesign/" target="_blank" rel="noopener noreferrer">(linkedin)</a>
            <a id="b1" href="https://drive.google.com/file/d/1ueUn_TopvQmTRSfS6azTl3WFIq8g8o_n/view?usp=sharing" target="_blank" rel="noopener noreferrer">(resume)</a>
          </div>
        </div>
      </div>


      <div id="contents">
        <div id="tt2">
          <div id="t">say you’re a ux designer without saying you’re a ux designer</div>
          <div id="b2">i scale stories with pixels.</div>
        </div>
        <div id="tt2">
          <div id="t">what stories are you sharing?</div>
          <Link to="/amazon" id="b2">(an amazon shopper who designs)</Link>
          <Link to="/andyou" id="b2">(a card deck for the viet diaspora)</Link>
          <Link to="/thesis" id="b2">(a collective narrative for students)</Link>
          <Link to="/interviews" id="b2">(an interview for introverts)</Link>
        </div>
        <div id="tt2">
          <div id="t">so, what’s your story?</div>
          <div id="b2">i'm a first-gen vietnamese american designer. such a statement was once unreal.
          that's why i design. to dream new futures and carry on the love and support that i grew from.</div>
        </div>

      </div>
    </div>
  );
}

export default Home;

